module.exports = __webpack_public_path__ + "img/2022_ram-1500.45eea2ce.png";